export const getGoogleMapConfig = (showLabels = false) => [
	{
		stylers: [{hue: '#2c3e50', saturation: 250}],
	},
	{
		featureType: 'all',
		elementType: 'labels',
		stylers: [{visibility: showLabels ? 'on' : 'off'}],
	},
	{
		featureType: 'road',
		elementType: 'geometry',
		stylers: [{lightness: 50}, {visibility: 'simplified'}],
	},
	{
		featureType: 'road',
		elementType: 'labels',
		stylers: [{visibility: 'off'}],
	},
]
